/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IMunicipio from './entidades/municipio';

export default class ModeloMunicipio {
    public consultarListaMunicipios() {
        return manejadorRest<IRespuesta<IMunicipio>>(
            () => seguridad.get('Municipio/ConsultarListaMunicipio'),
            true
        );
    }
}
